module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//18.jpg?1707cc63800cb70a63c7624b5e8ef882";